<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="微信公众号配置" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="公众号名称"
              :labelCol="{lg: {span: 6}, sm: {span: 6}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.wechat_name" v-decorator="['wechat_name',{rules: [{ required: data.wechat_name, message: '请输入公众号名称' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.wechat_name">{{ data.wechat_name || '--' }}</span>
              <span v-if="!data.wechat_name">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="APP_ID"
              :labelCol="{lg: {span: 6}, sm: {span: 6}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.wechat_appId" v-decorator="['wechat_appId',{rules: [{ required: data.wxapp_appId, message: '请输入公众号APP_ID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.wechat_appId">{{ data.wechat_appId || '--' }}</span>
              <span v-if="!data.wechat_appId">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="APP_SECRET"
              :labelCol="{lg: {span: 6}, sm: {span: 6}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.wechat_secret" v-decorator="['wechat_secret',{rules: [{ required: data.wechat_secret, message: '请输入公众号SECRET' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.wechat_secret">{{ data.wechat_secret || '--' }}</span>
              <span v-if="!data.wechat_secret">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="TOKEN"
              :labelCol="{lg: {span: 6}, sm: {span: 6}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.wechat_token" v-decorator="['wechat_token',{rules: [{ required: data.wechat_token, message: '请输入公众号TOKEN' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.wechat_token">{{ data.wechat_token || '--' }}</span>
              <span v-if="!data.wechat_token">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="AESKEY"
              :labelCol="{lg: {span: 6}, sm: {span: 6}}"
              :wrapperCol="{lg: {span: 12}, sm: {span: 12} }">
              <a-input v-show="isEdit && data.wechat_aesKey" v-decorator="['wechat_aesKey',{rules: [{ required: data.wechat_aesKey, message: '请输入公众号AESKEY' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit && data.wechat_aesKey">{{ data.wechat_aesKey || '--' }}</span>
              <span v-if="!data.wechat_aesKey">********</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="微信登陆回调地址"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['wechat_callback',{rules: [{ required: true, message: '请输入回调地址' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.wechat_callback || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {}
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'wechat' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
